import styled from '@emotion/styled'
import { CssBaseline } from '@mui/material'
import { esES } from '@mui/material/locale'
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import AutomationController from 'automations/AutomationController'
import ProvidersNest from 'common/components/ProvidersNest'
import SnackbarCloseButton from 'common/components/SnackbarCloseButton'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import RoutesController from 'features/routing/components/RoutesController'
import { MaterialDesignContent, SnackbarProvider } from 'notistack'
import { useContext, useEffect, useState } from 'react'

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': {
    fontSize: '1em',
  },
}))

function App() {
  const { themeController } = useContext(CustomThemeContext) //new ThemeManager()

  if (themeController?.activeTheme.options.fullHideMenu)
    localStorage.setItem('NO_EXPAND_MENU', 'true')

  const [themePallete, setThemePallete] = useState(
    createTheme(
      {
        palette: themeController?.pallete,
        components: themeController?.activeTheme?.components_styles ?? {},
        typography: themeController?.typography,
        cssVariables: true,
        hide: themeController?.hide,
      },
      esES,
    ),
  )

  useEffect(() => {
    if (!themeController) return

    setThemePallete(
      createTheme(
        {
          palette: themeController?.pallete,
          components: themeController?.activeTheme?.components_styles ?? {},
          typography: themeController?.typography,
          cssVariables: true,
          hide: themeController?.hide,
        },
        esES,
      ),
    )
  }, [themeController])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themePallete}>
          <CssBaseline enableColorScheme />
          <ProvidersNest>
            <SnackbarProvider
              action={(key) => <SnackbarCloseButton snackbarKey={key} />}
              autoHideDuration={5000}
              Components={{
                default: StyledMaterialDesignContent,
                info: StyledMaterialDesignContent,
                error: StyledMaterialDesignContent,
                success: StyledMaterialDesignContent,
                warning: StyledMaterialDesignContent,
              }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              maxSnack={5}
              SnackbarProps={{}}
            >
              <AutomationController />
              <RoutesController />
            </SnackbarProvider>
          </ProvidersNest>
        </ThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  )
}

export default App
